import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { Apollo, ApolloModule } from 'apollo-angular';
import { HttpLink, HttpLinkModule } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';

import { DefaultOptions } from '../../../node_modules/apollo-client/ApolloClient';
import { environment } from '../../environments/environment';
import { AuthEffects } from './effects/auth.effects';
import { OrganizationEffects } from './effects/organization.effects';
import { reducers } from './reducers';
import { AuthService } from './services/auth.service';
import { OrganizationService } from './services/organization.service';

@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    ApolloModule,
    HttpLinkModule,
    CommonModule
  ]
})
export class AfbGraphqlApiModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AfbGraphqlApiModule,
      providers: [AuthService, OrganizationService]
    };
  }
  static forRootWithState(): ModuleWithProviders {
    return {
      ngModule: AfbGraphqlApiWithStateModule,
      providers: [AuthService, OrganizationService]
    };
  }
  // Skips if AfbGraphqlApiModule is being loaded in module other than AppModule
  constructor(
    @Optional() @SkipSelf() parentModule: AfbGraphqlApiModule,
    private apollo: Apollo,
    private httpLink: HttpLink
  ) {
    if (parentModule) {
      throw new Error('AfbGraphqlApiModule is already loaded');
    }

    const noCacheOptions: DefaultOptions = {
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore'
      },
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
      }
    };

    apollo.create({
      link: httpLink.create({
        uri: environment.afbGraphqlHost
      }),
      cache: new InMemoryCache(),
      defaultOptions: noCacheOptions
    });
    apollo.create(
      {
        link: httpLink.create({
          uri: environment.afbUnprotectedGraphqlHost
        }),
        cache: new InMemoryCache(),
        defaultOptions: noCacheOptions
      },
      'unprotected'
    );
  }
}

@NgModule({
  imports: [
    StoreModule.forFeature('afbGraphqlApi', reducers),
    EffectsModule.forFeature([AuthEffects, OrganizationEffects]),
    BrowserModule,
    HttpClientModule,
    ApolloModule,
    HttpLinkModule,
    CommonModule
  ]
})
export class AfbGraphqlApiWithStateModule {
  constructor(
    @Optional() @SkipSelf() parentModule: AfbGraphqlApiWithStateModule,
    private apollo: Apollo,
    private httpLink: HttpLink
  ) {
    if (parentModule) {
      throw new Error('AfbGraphqlApiModule is already loaded');
    }

    const noCacheOptions: DefaultOptions = {
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore'
      },
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
      }
    };

    apollo.create({
      link: httpLink.create({
        uri: environment.afbGraphqlHost
      }),
      cache: new InMemoryCache(),
      defaultOptions: noCacheOptions
    });
    apollo.create(
      {
        link: httpLink.create({
          uri: environment.afbUnprotectedGraphqlHost
        }),
        cache: new InMemoryCache(),
        defaultOptions: noCacheOptions
      },
      'unprotected'
    );
  }
}
